import React, { useState } from "react";
import { Fab, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IMAGECONFIG } from "../../config/image-config";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";

const BeagleFabModalComponent = () => {
  const [open, setOpen] = useState(false);
  const [isSmallWindow, setIsSmallWindow] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const resizeHandler = () => setIsSmallWindow(!isSmallWindow);

  const fabStyle = {
    position: "fixed",
    bottom: "40px",
    right: "102px",
    height: "0px",
    width: "0px",
  };

  const chatbotStyle = {
    position: "fixed",
    bottom: isSmallWindow ? "27px" : "25px",
    right: isSmallWindow ? "18px" : "1.5%",
    width: isSmallWindow ? "350px" : "35%",
    height: open ? "80%" : "80%",
    bgcolor: "background.paper",
    boxShadow: "0px 9.638px 79.514px 0px rgba(0, 0, 0, 0.25)",
    borderRadius: "8px",
    overflow: "hidden",
    transition: "height 0.3s ease",
    display: open ? "block" : "none",
    padding: 0,
  };

  const headerStyle = {
    position: "absolute",
    top: "1.5px",
    right: "1.5px", 
    zIndex: 1,
  };

  return (
    <div>
      {!open && (
        <Fab color="primary" style={fabStyle} onClick={handleOpen}>
          <img src={IMAGECONFIG.ASKBEAGLE} alt="Ask Beagle" />
        </Fab>
      )}

      {/* Chatbot modal */}
      <Box sx={chatbotStyle}>
        {/* Close button moved to absolute position within the modal */}
        {open && (
          <Box sx={headerStyle}>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon sx={{ color: "#25D4CF", fontSize: "1.2rem", opacity: 0.7 }} />
            </IconButton>
          </Box>
        )}


        {/* Iframe is always present */}
        <iframe
          src={process.env.REACT_APP_BEAGLE_GPT}
          width="100%"
          height="100%"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          style={{ borderRadius: "8px", transition: "height 0.3s ease" }}
        />
      </Box>
    </div>
  );
};

export default BeagleFabModalComponent;